/*******************************************************************************
* Licensed Materials - Property of HCL 
* (c) Copyright HCL Technologies Ltd. 2020. All Rights Reserved. 

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/
/**
 * Component that create a pie chart with labels and plane
 * required params:
 *  - data: object with the information to display
 *  Example : 
 *  const data = [
        { data: 60, color: "green", info: "Completed" },
        { data: 2, color: "orange", info: "Warning" },
        { data: 2, color: "red", info: "Errors" },
    ];
 * other params:
 *  - planeColor
 */

import React from "react";
import PropTypes from "prop-types";
import Text from "../GUI/Text";

function PieChart({ data, textColor = "#c6c6c6", ...otherAttributes }) {
    // Takes labels and return an array of Text ready to be renderized by React
    const createLabels = () => {
        return data.map((value, index) => {
            return (
                <a-entity key={index} position={`0 ${-0.2 * index} 0`}>
                    <a-box
                        position="-0.6 0 0.025"
                        color={value.color}
                        width="0.1"
                        height="0.1"
                        depth="0.05"
                    />
                    <Text
                        text={value.info + ":"}
                        position="-0.5 0 0"
                        align="left"
                        width="1"
                        size="p4"
                    />
                    <Text
                        value={value.data}
                        position="0.6 0 0"
                        align="right"
                        width="0.2"
                        size="p5"
                    />
                </a-entity>
            );
        });
    };
    const drawPie = () => {
        const sum = data.reduce((p, c) => {
            return p + c.data;
        }, 0);
        let currentTheta = 0;
        return data.map((elem, id) => {
            const tetha = (elem.data / sum) * 360;
            const cylinder = (
                <a-cylinder
                    key={id}
                    height={0.1}
                    radius={0.8}
                    color={elem.color}
                    theta-start={currentTheta}
                    theta-length={tetha}
                />
            );
            currentTheta += tetha;

            return cylinder;
        });
    };
    return (
        <a-entity class="PieChart" {...otherAttributes}>
            <a-entity position="0 0.5 0.05" rotation="90 0 0">
                {drawPie()}
            </a-entity>
            <a-entity position="0 -0.5 0.05">{createLabels()}</a-entity>
        </a-entity>
    );
}

// requiring dataPoints
PieChart.propTypes = {
    data: PropTypes.array.isRequired
};

export default PieChart;
